import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  getFirestore,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import "../../firebase/firebase";
import { Link } from "react-router-dom";

const Stories = () => {
  const [stories, setStories] = useState([]);
  const db = getFirestore();

  useEffect(() => {
    const fetchStories = async () => {
      const snap = await getDocs(collection(db, "stories"));
      setStories(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    };
    fetchStories();
  }, [db]);

  const togglePublish = async (story) => {
    const action = story.published ? "unpublish" : "publish";
    const confirmed = window.confirm(
      `Are you sure you want to ${action} this story?`,
    );

    if (!confirmed) return;

    await updateDoc(doc(db, "stories", story.id), {
      published: !story.published,
    });

    setStories((prev) =>
      prev.map((s) =>
        s.id === story.id ? { ...s, published: !s.published } : s,
      ),
    );
  };

  const deleteStory = async (storyId) => {
    const confirmed = window.confirm(
      "This action is permanent. Are you sure you want to delete this story?",
    );

    if (!confirmed) return;

    await deleteDoc(doc(db, "stories", storyId));

    setStories((prev) => prev.filter((s) => s.id !== storyId));
  };

  return (
    <div className="page-container">
      <div className="d-flex justify-content-between align-items-center mt-3">
        <h1>Web Stories</h1>
        <Link to="new" className="btn btn-primary">
          Create Story +
        </Link>
      </div>

      <table className="table mt-4 table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Slug</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {stories.map((story, i) => (
            <tr key={story.id}>
              <td>{i + 1}</td>
              <td>{story.title}</td>
              <td>{story.slug}</td>
              <td>{story.published ? "Published" : "Draft"}</td>
              <td>
                <div className="dropdown">
                  <button
                    className="btn btn-sm btn-secondary dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    Actions
                  </button>

                  <ul className="dropdown-menu">

                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => togglePublish(story)}
                      >
                        {story.published ? "Unpublish" : "Publish"}
                      </button>
                    </li>

                    <li>
                      <button
                        className="dropdown-item text-danger"
                        onClick={() => deleteStory(story.id)}
                      >
                        Delete
                      </button>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Stories;
